import React from 'react';

const ErrorContent = () => {
  return (
    <div className="hmf-display-flex hmf-flex-column hmf-justify-content-center hmf-align-items-center hmf-mt-l">
      <p className="quickview-error hmf-header-m">
        WE&apos;RE SORRY, BUT QUICKVIEW IS UNAVAILABLE AT THIS TIME.
      </p>
    </div>
  );
};

export default ErrorContent;
